module.exports = __webpack_public_path__ + "static/img/heat-transfer-plate.cde8fc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/matlab/images/heat-transfer-plate.jpg
// module id = OAgw
// module chunks = 1